import { createContext } from 'react';

const clientsContext = createContext();

export default clientsContext;
